var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full relative"},[_c('div',{ref:"mounter",staticClass:"full absolute"}),_c('Scene',{on:{"ready":function (v) { _vm.scene = v; _vm.init() }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }